<template>
  <div id="header-mobile">
      <div class="content-header-mobile-wrapper">
          <div class="image-success-wrapper">
              <img :src="success" alt="image-success" id="image-success">
          </div>
          <div class="first-greeting">
              <p class="first-greeting-value">Selamat Anda sudah menyelesaikan semua aktivitas program</p>
          </div>
          <div class="second-greeting">
              <p class="second-greeting-value">Anda berhasil mendapatkan sertifikat kepesertaan program ini</p>
          </div>
      </div>
  </div>
</template>

<script>

import ImageSerfitikat from '../../assets/images/sertifikat/index'

export default {
  name: 'HeaderMobile',
  data: () => ({
    success: ImageSerfitikat.success
  })
}
</script>

<style scoped>
p{
    margin-bottom: 0px;
}

#header-mobile{
    padding: 20px 0px;
}

.content-header-mobile-wrapper{
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

#image-success{
    width: 200px;
}

.first-greeting{
    margin: 10px 0px;
}

.first-greeting-value{
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    color: rgba(0, 0, 0, 0.7);
}

.second-greeting{
    margin: 10px 0px;
    width: 80%;
}

.second-greeting-value{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    text-align: center;
    color: rgba(0, 0, 0, 0.7);
}
</style>
